import React from "react";
import styles from "./AppErrorFallback.module.css";
import { errorBoundaryFallback } from "../../../locales/en";

const AppErrorFallback = () => {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>
        {errorBoundaryFallback.appFallback.title}
      </h1>
      <p className={styles.subtitle}>
        {errorBoundaryFallback.appFallback.subtitle}
      </p>
      <button className={styles.button} onClick={handleRefresh}>
        {errorBoundaryFallback.appFallback.buttonText}
      </button>
    </div>
  );
};

export default AppErrorFallback;
